import { Box, useTheme } from '@mui/material';

/**
 * @param {{ segments: { value: number, color: string }[] }} props
 * value is a percentage (0-100) for each segment
 */
const StackedProgressBar = ({ segments, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: 10,
        borderRadius: 5,
        overflow: 'hidden',
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        ...sx,
      }}
    >
      {segments.map((segment, index) => (
        <Box
          key={index}
          sx={{
            width: `${segment.value}%`,
            backgroundColor: segment.color,
            transition: 'width 0.3s ease',
          }}
        />
      ))}
    </Box>
  );
};

export default StackedProgressBar;
